class MscToOrderType {
  constructor(code, chineseName, englishName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
}

export const CODE_NAME = 'MscToOrderType'

export const MSC_TO_ORDER_TYPE_BY_ORDER = new MscToOrderType('ByOrder', 'BY ORDER', 'BY ORDER')
export const MSC_TO_ORDER_TYPE_BY_ORDER_OF = new MscToOrderType('ByOrderOf', 'BY ORDER OF', 'BY ORDER OF')
export const MSC_TO_ORDER_TYPE_BY_ORDER_OF_SHIPPER = new MscToOrderType('ByOrderOfShipper', 'BY ORDER OF SHIPPER', 'BY ORDER OF SHIPPER')
export const MSC_TO_ORDER_TYPE_FOR_APPLICANT = new MscToOrderType('ForApplicant', 'FOR APPLICANT', 'FOR APPLICANT')
export const MSC_TO_ORDER_TYPE_ORDER_OF_SHIPPER = new MscToOrderType('OrderOfShipper', 'ORDER OF SHIPPER', 'ORDER OF SHIPPER')
export const MSC_TO_ORDER_TYPE_TO_APPLICATION = new MscToOrderType('ToApplicant', 'TO APPLICANT', 'TO APPLICANT')
export const MSC_TO_ORDER_TYPE_TO_ORDER = new MscToOrderType('ToOrder', 'TO ORDER', 'TO ORDER')
export const MSC_TO_ORDER_TYPE_TO_ORDER_OF = new MscToOrderType('ToOrderOf', 'TO ORDER OF', 'TO ORDER OF')
export const MSC_TO_ORDER_TYPE_TO_ORDER_OF_SHIPPER = new MscToOrderType('ToOrderOfShipper', 'TO ORDER OF SHIPPER', 'TO ORDER OF SHIPPER')
export const MSC_TO_ORDER_TYPE_TO_ORDER_OF_THE_SHIPPER = new MscToOrderType('ToOrderOfTheShipper', 'TO ORDER OF THE SHIPPER', 'TO ORDER OF SHIPPER')
export const MSC_TO_ORDER_TYPE_TO_SHIPPERS_ORDER = new MscToOrderType('ToShippersOrder', 'OT SHIPPER’S ORDER', 'OT SHIPPER’S ORDER')
export const MSC_TO_ORDER_TYPE_TO_THE_ORDER = new MscToOrderType('ToTheOrder', 'TO THE ORDER', 'TO THE ORDER')
export const MSC_TO_ORDER_TYPE_TO_THE_ORDER_OF = new MscToOrderType('ToTheOrderOf', 'TO THE ORDER OF', 'TO THE ORDER OF')
export const MSC_TO_ORDER_TYPE_TO_THE_ORDER_OF_SHIPPER = new MscToOrderType('ToTheOrderOfShipper', 'TO THE ORDER OF SHIPPER', 'TO THE ORDER OF SHIPPER')
export const MSC_TO_ORDER_TYPES =
  [
    MSC_TO_ORDER_TYPE_BY_ORDER,
    MSC_TO_ORDER_TYPE_BY_ORDER_OF,
    MSC_TO_ORDER_TYPE_BY_ORDER_OF_SHIPPER,
    MSC_TO_ORDER_TYPE_FOR_APPLICANT,
    MSC_TO_ORDER_TYPE_ORDER_OF_SHIPPER,
    MSC_TO_ORDER_TYPE_TO_APPLICATION,
    MSC_TO_ORDER_TYPE_TO_ORDER,
    MSC_TO_ORDER_TYPE_TO_ORDER_OF,
    MSC_TO_ORDER_TYPE_TO_ORDER_OF_SHIPPER,
    MSC_TO_ORDER_TYPE_TO_ORDER_OF_THE_SHIPPER,
    MSC_TO_ORDER_TYPE_TO_SHIPPERS_ORDER,
    MSC_TO_ORDER_TYPE_TO_THE_ORDER,
    MSC_TO_ORDER_TYPE_TO_THE_ORDER_OF,
    MSC_TO_ORDER_TYPE_TO_THE_ORDER_OF_SHIPPER
  ]
